import React from 'react';
import { Navigate, Outlet } from 'react-router-dom'

import AuthService from "../services/auth";
import SessionEnded from "../pages/web/SessionEnded";
import { readRemoteSession, isWebSession, readWebReturn } from "../context/RemoteLaunchContext";

const useAuth=()=>{
    const auth = AuthService.getCurrentAuth()
    if(auth){
        return true
    } else {
        return false
    }
}

/**
 * WEB-410 -- a web player must never be shown the kiosk login.
 *
 * /login asks for a username and password that belongs to venue staff. A
 * patron who arrived at /go/<slug> has neither, so bouncing them there is a
 * dead end: nothing they can type, and nothing telling them why. It is what
 * happens today when their session expires and they come back to the tab.
 *
 * The session itself says which kind of visit this was, so an expired web
 * visit ends on a page that offers a new one instead.
 */
const  PrivateRoute=(props) => {
    const auth = useAuth()
    if(auth) return <Outlet/>

    // Either signal is enough. The live session knows this was a web visit but
    // dies with the tab; the remembered return survives the tab. A player who
    // closed the browser and came back tomorrow has only the second, and they
    // are exactly the player who used to end up staring at the kiosk login.
    const session = readRemoteSession()
    if(session && isWebSession(session)) return <SessionEnded/>
    if(readWebReturn()) return <SessionEnded/>

    return <Navigate to="/login"/>
}

export default PrivateRoute;
